import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { authGetUserLanguage } from "../services/auth";
import ChatApp from "../features/chat/ChatApp";

export default function App() {
  const { i18n } = useTranslation();
  const [languageInitialized, setLanguageInitialized] = useState(false);
  useEffect(() => {
    if (languageInitialized) {
      console.log('[App] Language already initialized, skipping');
      return; // ✅ Skip als al geïnitialiseerd
    }

    const initLanguage = async () => {
      try {
        const tokenLang = authGetUserLanguage();
        console.log("[App] Token language (raw):", tokenLang);
        
        const normalizedLang = tokenLang?.toLowerCase();
        console.log("[App] Token language (normalized):", normalizedLang);

        if (normalizedLang && ["nl", "fr", "de", "en"].includes(normalizedLang)) {
          await i18n.changeLanguage(normalizedLang);
          console.log("[App] User language set to:", normalizedLang);
          setLanguageInitialized(true);
          return;
        }

        console.log("[App] No valid language found, using fallback:", i18n.language);
        setLanguageInitialized(true);
      } catch (err) {
        console.error("[App] Error setting user language:", err);
        setLanguageInitialized(true);
      }
    };

    initLanguage();
  }, [i18n, languageInitialized]); // ✅ Voeg languageInitialized toe

  return <ChatApp />;
}